
 <kendo-badge-container>
    <button kendoButton look="flat" icon="user" (click)="showLinkedUsers()" type="button"> </button>
    <kendo-badge *ngIf="!counter" size="small" themeColor="error" [align]="align" [position]="'inside'" >
        <kendo-icon name="error" class="k-badge-icon"></kendo-icon>
    </kendo-badge>
    <kendo-badge *ngIf="counter>0" size="small" themeColor="success" [align]="align" [position]="'inside'" >
        {{counter}}
    </kendo-badge>
 </kendo-badge-container>

 <div kendoDialogContainer #linkedUsersDialog></div>